var themeUtil = require('webpack-theme-color-replacer/themeUtil.js')

module.exports = {
    title: 'app',
    description: 'kayang app',
    themeColor: '#1989fa',
    titleBg: '#001528',
    titleFg: '#fdfdfd',
    footerBg: '#fefefe',

    getThemeColors: function (primaryColor, otherColors) {
        otherColors.push(themeUtil.varyColor.mix('#000', primaryColor, 0.7))
        return themeUtil.getMyColors(primaryColor, otherColors);//element-ui主色系列
    }
}
